import http from "@/services/http";

// Assinatura do AlugUp (planos e pagamento via Pix)
export const billing = () => {
  async function getOne() {
    const {data} = await http.get('/billing/getOne');
    return data;
  }

  async function checkout(plan, months) {
    const response = await http.post('/billing/checkout', { plan, months });
    return response.data;
  }

  // Cartão de crédito/débito: dados do Card Payment Brick (token gerado no navegador)
  async function payCard(dados) {
    const response = await http.post('/billing/card', dados);
    return response.data;
  }

  async function getPayment(id) {
    const {data} = await http.get('/billing/payment/'+id);
    return data;
  }

  async function payments() {
    const {data} = await http.get('/billing/payments');
    return data;
  }

  return {getOne, checkout, payCard, getPayment, payments};
}
